export default {
  LOGIN: "login",
  SELECT_LESSON_PAGE: "selectLessonPage",
  REPORT_CARD: "reportCard",
  LIBRARY: "library",
  CALENDAR: "calendar",
  JOURNAL: "journal",
  CLASS: "class",
  TEACHER_ROOM: "teacherRoom",
  PARENT_ROOM: "parentRoom",
  LESSON: "lesson",
};
